// General
import "./ethnicity-filter-dialog.scss";
import { useEffect, forwardRef } from "react";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateEthnicityFilterDialog } from "../../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// Material UI
import { Dialog, Slide } from "@mui/material";
// Components
import EthnicityFilter from "../../../elements/filters/ethnicity-filter/ethnicity-filter";

const EthnicityFilterDialog = () => {
  // Redux variables
  const ethnicityFilterDialog = useSelector(
    (state) => state.dialog.ethnicityFilterDialog
  );
  const dispatch = useDispatch();

  // Lifecycle | Mounted
  useEffect(() => {
    if (!ethnicityFilterDialog) return;

    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-EthnicityFilter-Dialog",
      },
    });
  }, [ethnicityFilterDialog]);

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateEthnicityFilterDialog(false));
  };

  return (
    <Dialog
      className="custom-bottom-sheet-dialog"
      fullScreen
      open={ethnicityFilterDialog}
      TransitionComponent={Transition}
      onClose={onCloseDialog}
    >
      <EthnicityFilter />
    </Dialog>
  );
};

export default EthnicityFilterDialog;

// Render Functions | MUI Dialog | Will not work if inside of the same render as the Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
